
import React, { useState } from 'react';
import { Eye, EyeOff, Copy, X, ArrowLeft, Loader2, AlertTriangle } from 'lucide-react';

const WarningModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = "Are you sure?", 
  message = "This action cannot be undone.", 
  confirmText = "Confirm", 
  cancelText = "Cancel",
  confirmButtonColor = "#ef4444" 
}) => {
  if (!isOpen) return null;

  return (
    <div className="warning-overlay" onClick={onClose}>
      <div className="warning-container" onClick={(e) => e.stopPropagation()}>
        <div className="warning-icon">
          <AlertTriangle size={24} />
        </div>
        
        <div className="warning-content">
          <h3 className="warning-title">{title}</h3>
          <p className="warning-message">{message}</p>
        </div>

        <div className="warning-actions">
          <button 
            onClick={onClose}
            className="warning-button warning-cancel"
          >
            {cancelText}
          </button>
          <button 
            onClick={onConfirm}
            className="warning-button warning-confirm"
            style={{ backgroundColor: confirmButtonColor }}
          >
            {confirmText}
          </button>
        </div>
      </div>

      <style jsx>{`
        .warning-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.6);
          backdrop-filter: blur(4px);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 2000;
          padding: 20px;
        }

        .warning-container {
          background: white;
          width: 100%;
          max-width: 400px;
          border-radius: 16px;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.3);
          padding: 24px;
          text-align: center;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          animation: warningSlideIn 0.2s ease-out;
        }

        @keyframes warningSlideIn {
          from {
            opacity: 0;
            transform: scale(0.95) translateY(10px);
          }
          to {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }

        .warning-icon {
          width: 48px;
          height: 48px;
          background: #fef3c7;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 16px;
          color: #f59e0b;
        }

        .warning-content {
          margin-bottom: 24px;
        }

        .warning-title {
          font-size: 18px;
          font-weight: 600;
          color: #1f2937;
          margin: 0 0 8px 0;
        }

        .warning-message {
          font-size: 14px;
          color: #6b7280;
          margin: 0;
          line-height: 1.5;
        }

        .warning-actions {
          display: flex;
          gap: 12px;
          justify-content: center;
        }

        .warning-button {
          padding: 10px 20px;
          border: none;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s;
          min-width: 80px;
        }

        .warning-cancel {
          background: #f3f4f6;
          color: #374151;
        }

        .warning-cancel:hover {
          background: #e5e7eb;
          transform: translateY(-1px);
        }

        .warning-confirm {
          background: #ef4444;
          color: white;
        }

        .warning-confirm:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4);
        }

        @media (max-width: 480px) {
          .warning-container {
            margin: 20px;
            max-width: calc(100% - 40px);
          }
          
          .warning-actions {
            flex-direction: column;
          }
          
          .warning-button {
            width: 100%;
          }
        }
      `}</style>
    </div>
  );
};

export default WarningModal;